class KlevuUrlRedirects {
  constructor () {
    if (window.theme.klevu.enable !== 'true' || !window.theme.klevu.apiKey) { return }
    this.initialise()
  }

  async initialise () {
    const urlRedirects = await this.getUrlRedirects()

    if (urlRedirects && urlRedirects.klevu_keywordUrlMap) {
      window.theme.urlRedirects = urlRedirects.klevu_keywordUrlMap
    }
  }

  async getUrlRedirects () {
    // https://docs.klevu.com/apis/url-redirects
    const KLEVU_API_URL = `https://js.klevu.com/klevu-js-v1/klevu-js-api/${window.theme.klevu.apiKey}-maps.json`

    try {
      const response = await fetch(KLEVU_API_URL)

      if (!response.ok) {
        throw new Error(`HTTP error! Status: ${response.status}`)
      }

      const data = await response.json()

      return data
    } catch (error) {
      console.error('Error fetching Klevu redirects:', error)
    }
  }
}

document.addEventListener('DOMContentLoaded', () => {
  window.BAO.klevuUrlRedirects = new KlevuUrlRedirects()
})
